import { countriesList, UUID } from '@cmg/common';
import defaultTo from 'lodash/defaultTo';

import { useGetOfferingCountryCodeQuery } from './graphql';

/**
 * Returns instruments[0].countryCode
 * If no countryCode exists, returns countriesList.Usa.countryCode
 */
export function useGetOfferingCountryCode(offeringId: UUID) {
  const { data } = useGetOfferingCountryCodeQuery({
    variables: { offeringId: offeringId },
    fetchPolicy: 'cache-first',
  });

  return defaultTo(
    data?.publishedOfferings?.items?.[0]?.instruments[0].countryCode,
    countriesList.Usa.countryCode
  );
}
